import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import HeaderBackendComponent from "../../components/Header/headerBackendMobile";
import OrdersIndex from "../../components/orders";
import OrdersDetailsComponent from "../../components/orders/orderDetails";
import OrdersDetailsBaekComponent from "../../components/orders/orderDetailsBaek";



const OrdersDetailBaekView = (props) => (
  <Container  className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Inschrijvingen" subtitle="Baek Voiture" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <HeaderBackendComponent />
  <OrdersDetailsBaekComponent billData={props.location.state}/>
    
  </Container>
);

export default OrdersDetailBaekView;
